const INVOICE_DRAFT_CREATED = 'invoiceDraftCreated'
const INVOICE_DRAFT_UPDATED = 'invoiceDraftUpdated'
const INVOICE_DRAFT_DELETED = 'invoiceDraftDeleted'
const INVOICE_DRAFT_SELECTED = 'invoiceDraftSelected'
const INVOICE_DRAFT_DESELECTED = 'invoiceDraftDeselected'
const SHOW_INVOICE_LISTS = 'showInvoiceLists'
const FOCUS_INVOICE_REF_FIELD = 'focusInvoiceRefField'

const INVOICE_CREATED = 'invoiceCreated'

export {
    INVOICE_DRAFT_CREATED,
    INVOICE_DRAFT_UPDATED,
    INVOICE_DRAFT_DELETED,
    INVOICE_DRAFT_SELECTED,
    INVOICE_DRAFT_DESELECTED,
    INVOICE_CREATED,
    SHOW_INVOICE_LISTS,
    FOCUS_INVOICE_REF_FIELD
}